import { CallerProperties, type CallerProperty, type Caller } from '@/models/caller';

const notUpdatableProperties: CallerProperty[] = ['id', 'stripeCustomerId'];

// update request don't need id
const isUpdatable = (prop: CallerProperty) => notUpdatableProperties.includes(prop) === false;

export const buildUpdateCallerRequest = (caller: Partial<Caller>): Partial<Caller> =>
  Object.fromEntries(CallerProperties.filter(isUpdatable).map((prop) => [prop, caller[prop]]));
